<template>
  <div class="grid-y flex-grow divide-y">
    <div class="flex-shrink-0 container-tabs padding-horizontal-2 flex flex-row justify-between">
      <RouterTabs :tabs="tabs"/>
    </div>
    <div class="cell auto flex">
      <div class="grid-x flex-grow">
        <div class="cell auto flex flex-grow cell-block-container">
          <router-view
            @save="save"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from 'lodash';
import RouterTabs from '@/components/RouterTabs.vue';

export default {
  components: {
    RouterTabs,
  },
  data() {
    return {
      tabs: [
        { title: 'Одиночное захоронение', push: { name: 'objects.new.single' } },
        { title: 'Семейное захоронение', push: { name: 'objects.new.family' } },
      ],
    };
  },
  methods: {
    ...mapActions({
      send: 'objects/ACT_CREATE_OBJECT',
    }),
    save(payload) {
      const data = payload;
      if (data?.createBurials?.length) {
        data.createBurials = data.createBurials.map((burial) => {
          const copy = cloneDeep(burial);
          copy.createPersons = copy.persons;
          delete copy.persons;
          return copy;
        });
      }
      this.send(data).then(() => {
        this.$router.push({
          name: 'objects',
        });
      });
    },
  },
};
</script>
